declare namespace $ {

	type $mol_view__sub_bog_card_footer_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_card_footer_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_card_footer_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_card_footer extends $mol_view {
		start( ): string
		Start( ): $mol_view
		center( ): string
		Center( ): $mol_view
		end( ): string
		End( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=footer.view.tree.d.ts.map